'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.load = load;
exports.setAction = setAction;
exports.setDNF = setDNF;
exports.setAttributes = setAttributes;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'action/LOAD';
var LOAD_SUCCESS = 'action/LOAD_SUCCESS';
var LOAD_FAIL = 'action/LOAD_FAIL';
var SET = 'action/SET';
var SET_SUCCESS = 'action/SET_SUCCESS';
var SET_FAIL = 'action/SET_FAIL';
var SET_DNF = 'action/SET_DNF';
var SET_DNF_SUCCESS = 'action/SET_DNF_SUCCESS';
var SET_DNF_FAIL = 'action/SET_DNF_FAIL';
var SET_ATTR = 'action/SET_ATTR';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        actions: action.result.data.actionList
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case SET:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case SET_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        setaction: action.result.data.actionList
      });
    case SET_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case SET_DNF:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case SET_DNF_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        dnf: action.result
      });
    case SET_DNF_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case SET_ATTR:
      return (0, _extends3.default)({}, state, {
        attr: action.attr
      });
    default:
      return state;
  }
}

// export function load(orderNo) {
//   return {
//     types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
//     promise: (client) => client.get('/getActions', {
//       params: {
//         orderNo: orderNo
//       }
//     })
//   };
// }

function load(query) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/queries', {
        params: {
          query: query,
          isGraph: true
        }
      });
    }
  };
}

function setAction(method, path, body) {
  var clientMethod = method ? method.toLowerCase() : null;
  return {
    types: [SET, SET_SUCCESS, SET_FAIL],
    promise: function promise(client) {
      return client[clientMethod]('/setAction', {
        params: {
          method: method, path: path, body: body
        }
      });
    }
  };
}

function setDNF(orderNo) {
  return {
    types: [SET_DNF, SET_DNF_SUCCESS, SET_DNF_FAIL],
    promise: function promise(client) {
      return client.put('/setDNF', {
        params: {
          orderNo: orderNo
        }
      });
    }
  };
}

function setAttributes(attr) {
  return {
    type: SET_ATTR,
    attr: attr
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/action.js
// module id = 103
// module chunks = 0